import Users from "./users";

import './users.scss';

export default Users;
